export default __webpack_public_path__ + "static/media/listbuilder-caution-selected.7cb0eb36.svg";